<!-- white-block template -->
<template>
  <div>
    <div class="content sphidden" v-if="item.rank < 3">
      <a :href="'category/' + item.categoryId + '.html#' + item.magazineId">
        <div
          class="magazineDescription vertical"
          v-if="!item.customMagazineDescription"
        >
          <img :src="item.coverImage" target="_blank" alt="" />
          <div v-html="item.magazineDescription"></div>
        </div>
        <div class="magazineDescription vertical" v-else>
          <img :src="item.coverImage" target="_blank" alt="" />
          <div v-html="item.customMagazineDescription"></div>
        </div>
      </a>
      <div class="content_r">
        <a :href="'category/' + item.categoryId + '.html#' + item.magazineId">
          <i class="fas fa-crown crownsize color_gold"></i>
          <span class="top5rank color_gold">{{ item.rank }}</span>
          <div class="magazineTitle vertical color_gold">
            {{ item.magazineTitle }}
          </div>
        </a>
      </div>
    </div>
    <div class="content sphidden" v-else>
      <div class="content_r">
        <a :href="'category/' + item.categoryId + '.html#' + item.magazineId">
          <i class="fas fa-crown crownsizeOver3 color_gold"></i>
          <span class="top5rankOver3 color_gold">{{ item.rank }}</span>
          <img :src="item.coverImage" target="_blank" alt="" class="imgOver3" />
          <div class="magazineTitle titleOver3 vertical color_gold" v-html="magazineTitle">
            {{ magazineTitle }}
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      magazineTitle: ''
    }
  },
  mounted() {
    this.magazineTitle = this.item.magazineTitle.replace("＜", '︿')
    this.magazineTitle = this.magazineTitle.replace("＞", '﹀')
  }
}
</script>

<style scoped>

.content {
  margin: 0 auto;
  display: flex;
  box-sizing: border-box;
  max-width: 800px;
  height: 100%;
}
.content_l {
  height: 100%;
}

.magazineDescription {
  font-size: 14px;
  height: auto;
  margin: 0 15px 0;
  padding: 17px 0 0;
  height: 500px;
  letter-spacing: 0.8px;
  word-break: normal;
  display: block;
}
.magazineDescription img {
  min-width: 125px;
  max-width: 125px;
  min-height: 125px;
  max-height: 125px;
  object-fit: cover;
  object-position: top center;
  float: left;
  margin: 0 0 10px 10px;
}
.content_r {
  max-width: 65px;
  display: block;
  text-align: center;
  margin: 0 5px 0 10px;
  height: 100%;
}
.crownsize {
  font-size: 42px;
}
.magazineTitle,
.top5rank {
  font-size: 20px;
  width: 100%;
}
.magazineTitle {
  width: 55px;
  margin: -5px auto 0;
  height: 380px;
  text-align: left;
  font-size: 18px;
  display: flex;
  writing-mode: vertical-rl;
  align-items: center;
  line-height: 1.4;
  letter-spacing: 1.5px;
}
.top5rank {
  font-size: 68px;
  display: block;
  margin-top: -15px;
  font-family: 'futura-pt', futura, 'Century Gothic', 游ゴシック体, YuGothic,
    'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', 游ゴシック, 'Yu Gothic',
    メイリオ, Meiryo, sans-serif;
  font-weight: 500;
}

.top5rankOver3 {
  font-size: 34px;
  display: block;

  font-family: 'futura-pt', futura, 'Century Gothic', 游ゴシック体, YuGothic,
    'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', 游ゴシック, 'Yu Gothic',
    メイリオ, Meiryo, sans-serif;
  font-weight: 500;
}
.crownsizeOver3 {
  font-size: 22px;
}
.imgOver3 {
  width: 70px;
  height: 70px;
  object-fit: cover;
}
.titleOver3 {
  font-size: 18px;
  margin: 10px auto 0;
  height: 320px;
}
.vertical {
  writing-mode: vertical-rl;
  -webkit-writing-mode: vertical-rl;
  -ms-writing-mode: vertical-rl;
}
.color_gold {
  color: #d2ac31;
}

.white-block__container {
  max-width: 1200px;
  /* width: 95%; */
  background: #fff;
}

.spVisible {
  display: none;
}


@media screen and (max-width: 1113px) {
.magazineDescription img {
  min-width: 100px;
  max-width: 100px;
  min-height: 100px;
  max-height: 100px;
}
}
</style>
